import { Tooltip } from 'primereact/tooltip';
import { splitId } from '../../../businessLogicService/splitIdsFromBackEnd';
import { FC } from 'react';

interface Props {
  data: {
    studentId: string;
    assessmentsTakenSinceLastPass: number;
  };
}

const ProgressColumnAssessment: FC<Props> = ({ data }) => {
  return (
    <>
      <Tooltip
        style={{ borderRadius: '20px' }}
        target={`.red-exclamation-target-${splitId(data.studentId)}`}
        mouseTrack
        position="bottom"
      >
        <p className="text-0 text-sm p-1" style={{ fontFamily: 'Poppins' }}>
          {`This may be a sign of student\n frustration. You might want to\n check in with this student.`}
        </p>
      </Tooltip>
      <div className="flex justify-content-center" style={{ fontFamily: 'Poppins' }}>
        <span>{data.assessmentsTakenSinceLastPass}</span>
        {data.assessmentsTakenSinceLastPass > 2 && (
          <span
            className={`pi pi-exclamation-triangle cursor-pointer ml-2 red-exclamation-target-${splitId(
              data.studentId,
            )}`}
            style={{ color: '#B71C1B' }}
          ></span>
        )}
      </div>
    </>
  );
};

export default ProgressColumnAssessment;
